import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{attrs:{"bottom":"","timeout":_vm.snackbar.timeout,"multi-line":_vm.snackbar.multiline === true,"color":_vm.snackbar.color},model:{value:(_vm.snackbar.visible),callback:function ($$v) {_vm.$set(_vm.snackbar, "visible", $$v)},expression:"snackbar.visible"}},[_vm._v("\n  "+_vm._s(_vm.snackbar.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }